import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { _setParticipantComment } from './ParticipantActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

const initialState = {
    field: '',
    value: '',
}

export const getParticipantCommentFormSlice = createAsyncThunk(
  'stop/getParticipantCommentFormSlice',
  async (params) => {
    const { url, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(url, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const participantCommentFormSlice = createSlice({
  name: 'stop/participantCommentFormSlice',
  initialState,
  reducers: {
    setParticipantComment: _setParticipantComment,
    resetParticipantComment: () => null,
  },
  extraReducers: {
    [getParticipantCommentFormSlice.fulfilled]: (state, action) => action.payload,
  },
});

export const {
    resetParticipantComment,
    setParticipantComment,
} = participantCommentFormSlice.actions;

export default participantCommentFormSlice.reducer;
